<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="drivershortwork" slot-scope="params">
        <p>{{ params.params.drivershortwork.split('，')[0] }}</p>
        <p>{{ params.params.drivershortwork.split('，')[1] }}</p>
      </template>
      <template slot="codriverwork" slot-scope="params">
        <p>{{ params.params.codriverwork.split('，')[0] }}</p>
        <p>{{ params.params.codriverwork.split('，')[1] }}</p>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "StaffAttendanceSummary",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'carwork',
      breadcrumb: [
        { name: "考勤管理" },
        { name: "考勤汇总" },
      ],
      formInline: {},
      formCtrl: [
        {
          label: "车队长",
          keyName: "fleet",
          placeholder: "选择车队长",
          type: "select",
          options: [],
          className: "carcap",
        },
        {
          label: "月份",
          keyName: "month",
          placeholder: "请选择月份",
          type: "month",
        },
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
        /*{
          label: "开始天数：",
          keyName: "startday",
          placeholder: "请填写开始天数",
          type: "number",
        },
        {
          label: "结束天数：",
          keyName: "endday",
          placeholder: "请填写结束天数",
          type: "number",
        },*/
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driverwork", label: "司机考勤", minwidth: 120 },
        { prop: "escortwork", label: "押运考勤", minwidth: 120 },
        { prop: "drivershortwork", label: "打短司机考勤(公司)", slot:"drivershortwork", minwidth: 120 },
        { prop: "codriverwork", label: "打短司机考勤(司机)", slot: "codriverwork", minwidth: 120 },
        { prop: "escortshortwork", label: "打短押运考勤(公司)", minwidth: 120 },
        { prop: "coescortwork", label: "打短押运考勤(押运)", minwidth: 120 },
      ],
      getListUrl: 'allrec',
      baseParams: ['month'],
    };
  },
  methods: {
    getOptions() {
      let url = `${this.baseUrl}/getfleet`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, team, month }) => {
        if (msg == 'success') {
          this.setFleet({ team })
          this.formInline.month = month
          this.$forceUpdate()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: '获取数据失败，请稍后再试！'
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSearchItemChange({ key }) {
        // console.log(key)
        if (['fleet', 'month'].includes(key)) {
        // console.log(this.formInline)
        this.getList()
      }
    },
  },
  created() {
    this.MONTH = this.CURR_MONTH
    this.$set(this.formInline, 'month', this.CURR_MONTH)
  },
  mounted() {
    this.getOptions();
    this.getList();
  },
};
</script>
<style lang="less" scoped>
/deep/ .fillet .el-form--inline .el-form-item:first-child {
  margin-right: 20px;
  
}
/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
    margin-right: 0px;
    padding-right: 80px;
    position: relative;
    &::after {
      position: absolute;
      content: "";
      right: 40px;
      top: 6px;
      width: 1px;
      height: 28px;
      overflow: hidden;
      background-color: #EBEDF0;
    }  
}

/*.carcap .el-input__inner {
  width: 122px;
  color: #303133;
  border: 1px solid #F4F6F7;
  background-color: #F4F6F7;
}*/
</style>